// Import the centralized API client
import apiClient from '../main-api/apiClient';

// Re-export the API client for backward compatibility
export const api = apiClient;

// Export the centralized API client as default
export default apiClient;

// Legacy exports for modules that still use the old structure
export const authAPI = {
  login: (credentials) => apiClient.post('/auth/login-with-auth0', credentials),
  validateAuth0: (token) => apiClient.post('/auth/validate-auth0', { auth0_token: token }),
  verifyMFA: (data) => apiClient.post('/auth/verify-mfa', data),
  setupPassword: (data) => apiClient.post('/auth/setup-password', data),
};

export const tenantsAPI = {
  // Tenant management endpoints
  getTenants: () => apiClient.get('/tenants'),
  getTenant: (id) => apiClient.get(`/tenants/${id}`),
  createTenant: (data) => apiClient.post('/tenants', data),
  updateTenant: (id, data) => apiClient.put(`/tenants/${id}`, data),
  deleteTenant: (id) => apiClient.delete(`/tenants/${id}`),
};

export const clinicsAPI = {
  // Clinic management endpoints
  getClinics: () => apiClient.get('/clinics'),
  getClinic: (id) => apiClient.get(`/clinics/${id}`),
  createClinic: (data) => apiClient.post('/clinics', data),
  updateClinic: (id, data) => apiClient.put(`/clinics/${id}`, data),
  deleteClinic: (id) => apiClient.delete(`/clinics/${id}`),
};

export const patientsAPI = {
  // Patient management endpoints
  getPatients: () => apiClient.get('/patients'),
  getPatient: (id) => apiClient.get(`/patients/${id}`),
  createPatient: (data) => apiClient.post('/patients', data),
  updatePatient: (id, data) => apiClient.put(`/patients/${id}`, data),
  deletePatient: (id) => apiClient.delete(`/patients/${id}`),
};

export const recordingAPI = {
  // Recording management endpoints
  getRecordings: () => apiClient.get('/recordings'),
  getRecording: (id) => apiClient.get(`/recordings/${id}`),
  createRecording: (data) => apiClient.post('/recordings', data),
  updateRecording: (id, data) => apiClient.put(`/recordings/${id}`, data),
  deleteRecording: (id) => apiClient.delete(`/recordings/${id}`),
  
  // Recording session endpoints
  getRecordingSession: (linkToken) => apiClient.get(`/recording/${linkToken}`),
  getSessionQuestions: (linkToken) => apiClient.get(`/recording/${linkToken}/questions`),
  uploadQuestionRecording: (linkToken, formData) => apiClient.post(`/recording/${linkToken}/upload-question`, formData),
  completeSession: (linkToken) => apiClient.post(`/recording/${linkToken}/complete-session`),
  getSessionStatus: (linkToken) => apiClient.get(`/recording/${linkToken}/status`),
  saveSummary: (linkToken, summaryData) => apiClient.post(`/recording/${linkToken}/save-summary`, summaryData),
};

export const vitalsAPI = {
  // Vital signs analysis endpoints
  analyzeVitals: (data) => apiClient.post('/vital-signs/analyze', data),
  getVitalSigns: () => apiClient.get('/vital-signs'),
  getVitalSign: (id) => apiClient.get(`/vital-signs/${id}`),
  createVitalSign: (data) => apiClient.post('/vital-signs', data),
  updateVitalSign: (id, data) => apiClient.put(`/vital-signs/${id}`, data),
  deleteVitalSign: (id) => apiClient.delete(`/vital-signs/${id}`),
};